import React from 'react';
import { useDocuments } from '../../documents/useData';
import { StatCounterGrid } from './shared';
import type { StatCounterItem } from './shared';

const DocumentsStatusCounters: React.FC<{ embedded?: boolean }> = ({ embedded }) => {
  const { total: draftTotal, isLoading: draftLoading } = useDocuments(1, '', {
    status: 'DRAFT',
    limit: 1,
  });
  const { total: inApprovalTotal, isLoading: inApprovalLoading } = useDocuments(1, '', {
    status: 'IN_APPROVAL',
    limit: 1,
  });
  const { total: approvedTotal, isLoading: approvedLoading } = useDocuments(1, '', {
    status: 'APPROVED',
    limit: 1,
  });

  const isLoading = draftLoading || inApprovalLoading || approvedLoading;

  const counters: StatCounterItem[] = [
    {
      key: 'draft',
      label: 'Draft',
      value: draftTotal ?? 0,
      href: '/documents',
      accent: 'bg-slate-500',
    },
    {
      key: 'in_approval',
      label: 'In approval',
      value: inApprovalTotal ?? 0,
      href: '/documents',
      accent: 'bg-amber-500',
    },
    {
      key: 'approved',
      label: 'Approved',
      value: approvedTotal ?? 0,
      href: '/documents',
      accent: 'bg-emerald-500',
    },
  ];

  return (
    <StatCounterGrid
      title="Documents · Status"
      counters={counters}
      isLoading={isLoading}
      embedded={embedded}
      viewAllPath="/documents"
    />
  );
};

export default DocumentsStatusCounters;
